<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/mprotectt",
		    "name": "MProtectt"
		  }
		},{
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@id": "https://www.protectt.ai/mprotectt/ios",
              "name": "iOS"
            }
          }		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li><a routerLink="/mprotectt"> MProtectt</a></li>
                    <li>></li>
                    <li>iOS</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>
<!-- End Introduction -->


<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray section-pt section-pb-60">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/ios/ios.webp" alt="Enhanced Security For Foolproof iOS Devices" class="og_image_url">
                        <!-- <div class="play-btn">
                        <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i
                                class="fa fa-play"></i></a>
                    </div> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="agency-benefits">
                    <div class="content">
                        <div class="">
                            <h2>Enhanced Security For Foolproof iOS Devices</h2>
                        </div>
                        <p>Is iOS safer than the Android operating system? Yes. Is it a hundred percent, foolproof
                            secure and immune from any threats? Absolutely not!</p>
                        <p>Apple iOS devices are premium smartphones and tablets that make them and their users a more
                            lucrative target for malicious attacks. Sophisticated cyber attacks on iOS are increasing as
                            users become susceptible to phishing attacks and transaction monitoring that lead to a
                            breach of privacy and data leakage. Just like any other operating system, there is little
                            your built-in security can do when faced with email fraud that contains harmful attachments
                            or malicious links.</p>
                        <p>MProtectt for iOS offers 360degree protection - from malware attacks that breach your bank
                            accounts to spyware that threatens your privacy. With our state-of-the-art security cloud,
                            we are always scanning the horizons for previously unknown threats to ensure your device
                            stays updated in today’s dynamic world beyond the existing, limited boundaries of iOS
                            security.</p>
                        <!-- <p>MProtectt™ provides your business and employees the flexibility to operate anywhere and access email without containerization.</p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="container">
    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img" style="text-align: end;">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/android/MProtectt-wifi.webp" alt="Secure your Mobile Wifi Security with our Mobile Security App" />
                </div>
            </div>
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Browse Worry-Free with Safe Wi-Fi</h3>
                    <p>Wi-Fi networks, especially unsecured, public networks at your local coffee shop or at the airport
                        can provide a gateway for hackers to gain access to your device and the data being transmitted
                        through the network. MProtectt safeguards
                        your device from such malicious attacks and alerts you to an unsafe Wi-Fi network. Our real-time
                        Wi-Fi Security works in the background and constantly monitors the security status of the
                        network you are connected to.
                    </p>
                </div>
            </div>

        </div>
    </div>
    <!-- /.row -->

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img" style="text-align: start;">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/android/MProtectt-browse.webp" alt="Get Secured Browsing" />
                </div>
            </div>

        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">

                    <h3>Click with Confidence of Secured Browsing</h3>
                    <p>MProtectt gives you the confidence to browse the web without worrying about fraudulent websites
                        that try to infect your phone or steal your personal information. We evaluate the authenticity
                        of every link you click, in real-time, to prevent you from being a victim of a potential
                        phishing attack. Our enhanced security measures, consists of scan IP Address, Host, Domain and
                        Sub Domain of every webpage you open on your device and immediately exposes any dangerous and
                        unsafe URLs from loading.
                    </p>

                </div>
            </div>

        </div>
        <!-- /.col-md-6 -->

    </div>
    <!-- /.row -->

    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img" style="text-align: end;">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/android/MProtectt-email.webp" alt="Secure your Emails with MProtectt" />
                </div>
            </div>
            <!-- <img src="assets/images/about/realtime-protection.webp" alt="realtime protection" class="img-60" /> -->
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Evaluate Your Email’s Security Quo</h3>
                    <p>Your email address is your most important asset - a digital address of all your information. Our
                        expansive database helps MProtectt track if your email address and the private information
                        associated with it on thousands of websites
                        across the internet has been compromised in a cyber-attack. This enables you to take preventive
                        steps to avoid any further losses in case your data has been leaked. With MProtectt, you get a
                        monthly report that offers a deep dive
                        into the security of your email address as well as recommendations to stay safe and secure.
                    </p>

                </div>
            </div>

        </div>
        <!-- /.col-md-6 -->

    </div>
    <!-- /.row -->
</div>

<!-- End Agency Benefits Area -->

<div style="padding: 50px 0;" class="mt-70 section-newsletter section-ptb bg_image bg-overlay">
    <div class="container">
        <div class="row newsletter-style-2 political-newsletter align-items-center">
            <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <div class="title">
                    <h2>Available on AppStore.</h2>
                </div>
            </div>
            <div style="text-align: right;" class="col-xl-6 col-lg-5 col-md-12 col-sm-12 col-12">
                <!-- <a class="btn btn-circle" href="https://apps.apple.com/al/app/mprotectt/id1584610887">Download</a> -->
                <a class="btn btn-rectangle" href="https://apps.apple.com/al/app/mprotectt/id1584610887">Download</a>
            </div>
        </div>
    </div>
</div>

<!-- Start Other Features -->
<div class="section-agency-benefit bg-gray">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>Why Choose MProtectt</h2>
                </div>
            </div>
        </div>
        <!-- Start App/File Based Attacks -->
        <!-- <div class="col-lg-12 ">
    <div class="section-title text-center">
      <h2>App Protectt Secures all App Layers</h2>
    </div>
  </div> -->
        <div class="container w-100">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon yellow">
                            <div class="front-content">
                                <!-- <i class="fa fa-trophy"></i> -->
                                <img src="assets/images/about-mobile-security/final-icons/1.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Automate Your Phone’s Security</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Automate Your Phone’s Security</h3>
                            <p>MProtectt allows you to schedule how frequently and when you would like the app to scan
                                the device to ensure your phone is always up-to-date on its safety check and without
                                interfering in your daily life.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <!-- <i class="fa fa-anchor"></i> -->
                                <img src="assets/images/about-mobile-security/final-icons/2.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Detailed Insights and Reports</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Detailed Insights and Reports</h3>
                            <p>MProtectt offers a comprehensive view of the state of your smartphone’s security on the
                                dashboard. Here, you can view when the phone is scheduled for the next scan as well as
                                see reports from your previous scans to understand
                                what malicious attacks you are up against.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <!-- <i class="fa fa-anchor"></i> -->
                                <img src="assets/images/about-mobile-security/final-icons/5.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Mic and Camera Alert</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Mic and Camera Alert</h3>
                            <p>Worried if the apps installed on your smartphone are listening to you? MProtectt gives
                                you the option to be alerted any time an app is accessing the mic or the camera on your
                                phone.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 content text-center">
            <!-- <a class="btn-circle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a> -->
            <a class="btn-rectangle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a>
        </div>
    </div>
</div>
<!-- End Other Features -->

<div class="section-agency-benefit section-pt bg-gray section-pb-60">
    <div class="container">
        <!-- <div class="row align-items-center"> -->
        <div class="row">
            <!-- <table  id="table-bg">
                <thead>
                    <tr>
                        <th>Features</th>
                        <th class="column2">Free</th>
                        <th>Basic</th>
                        <th>Premium</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td id="table-text">App Scan</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Device Security</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Wi-Fi Security</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">ID Scan</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Battery Booster</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Virus / Malware Protection</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Breach Report</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Privacy Profile</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Memory Booster</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">New App Installation Check</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Application Profile</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Web Browsing Security</td>
                        <td style="color: red;">✖</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Schedule Device Scanning</td>
                        <td style="color: red;">✖</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td id="table-text">Anti Theft</td>
                        <td style="color: red;">✖</td>
                        <td style="color: red;">✖</td>
                        <td style="color: green;">✔</td>
                    </tr>
                    <tr>
                        <td style="border: none;" id="table-text"></td>
                        <td></td>
                        <td><a style="background: grey; border: grey; color: #fff" target="_blank"class="btn" href="https://play.google.com/store/apps/details?id=ai.protectt.mobileprotectt">Download</a></td>
                        <td><a class="btn" target="_blank" style="color: #fff" href="https://play.google.com/store/apps/details?id=ai.protectt.mobileprotectt">Download</a></td>
                    </tr>
                </tbody>
            </table> -->
            <div class="col-1 d-none d-lg-block"></div>
            <div class="col-md-12 col-lg-10 text-center">
                <img src="../../../assets/images/ios_page.webp" alt="table" class="img-fluid">
            </div>
            <div class="col-1 d-none d-lg-block"></div>
        </div>
        <div class="row formedium">
            <div class="col-md-5 col-lg-6"></div>
            <div class="col-md-6 col-lg-5">
                <div class="row">
                    <div class="col-md-2 d-none d-md-block d-lg-none"></div>
                    <div class="col-md-5 col-lg-5">
                        <a class="btn-rectangle btn-transparent btn careerbtn1"
                            href="https://apps.apple.com/us/app/mprotectt/id1584610887"
                            target="_blank">Download</a>
                    </div>

                    <div class="col-md-5 col-lg-6 text-center">
                        <a class="btn-rectangle btn-transparent btn careerbtn2"
                            href="https://apps.apple.com/us/app/mprotectt/id1584610887"
                            target="_blank">Download</a>
                    </div>
                    <!-- <div class="col-md-1 d-none d-md-block d-lg-none"></div> -->
                </div>
            </div>
        </div>
        <div class="row tillsmall">
            <div class="col-6"></div>
            <div class="col-6 rescenter1">
                <a class="btn-rectangle btn-transparent btn"
                            href="https://apps.apple.com/us/app/mprotectt/id1584610887"
                            target="_blank">Download</a>
            </div>
        </div>
    </div>
</div>

<!-- <div class="section-agency-benefit section-pt bg-gray section-pb-60 d-md-none">
    <div  class="container align-items-center">
        <div class="col-lg-12">
            <div class="section-title text-center">
                <h2>Features</h2>
            </div>
        </div>
    </div>
    <div class="container">
        <div  class="tabs">
            <div class="tab">
                <input type="checkbox" id="chck2">
                <label class="tab-label" for="chck2">Basic</label>
                <div class="tab-content">
                    <ul>
                        <li><span style="color: green;">✔</span> App Scan</li>
                        <li><span style="color: green;">✔</span> Device Security</li>
                        <li><span style="color: green;">✔</span> Wi-Fi Security</li>
                        <li><span style="color: green;">✔</span> ID Scan</li>
                        <li><span style="color: green;">✔</span> Battery Booster</li>
                        <li><span style="color: green;">✔</span> Virus / Malware Protection</li>
                        <li><span style="color: green;">✔</span> Breach Report</li>
                        <li><span style="color: green;">✔</span> Privacy Profile</li>
                        <li><span style="color: green;">✔</span> Memory Booster</li>
                        <li><span style="color: green;">✔</span> New App Installation Check</li>
                        <li><span style="color: green;">✔</span> Application Profile</li>
                    </ul>
                    <a style="background: grey; border: grey;" class="btn" href="https://play.google.com/store/apps/details?id=ai.protectt.mobileprotectt">Buy Basic <br>₹499 / yr</a>
                </div>
            </div>
            <div class="tab">
                <input type="checkbox" id="chck3">
                <label class="tab-label" for="chck3">Premium</label>
                <div class="tab-content">
                    <ul>
                        <li><span style="color: green;">✔</span> App Scan</li>
                        <li><span style="color: green;">✔</span> Device Security</li>
                        <li><span style="color: green;">✔</span> Wi-Fi Security</li>
                        <li><span style="color: green;">✔</span> ID Scan</li>
                        <li><span style="color: green;">✔</span> Battery Booster</li>
                        <li><span style="color: green;">✔</span> Virus / Malware Protection</li>
                        <li><span style="color: green;">✔</span> Breach Report</li>
                        <li><span style="color: green;">✔</span> Privacy Profile</li>
                        <li><span style="color: green;">✔</span> Memory Booster</li>
                        <li><span style="color: green;">✔</span> New App Installation Check</li>
                        <li><span style="color: green;">✔</span> Application Profile</li>
                        <li><span style="color: green;">✔</span> Web Browsing Security</li>
                        <li><span style="color: green;">✔</span> Schedule Device Scanning</li>
                        <li><span style="color: green;">✔</span> Anti Theft</li>
                    </ul>
                    <a class="btn" href="https://play.google.com/store/apps/details?id=ai.protectt.mobileprotectt">Buy Premium <br>₹599 / yr</a>
                </div>
            </div>
        </div>
    </div>
</div> -->



<!-- Start Testimonial Style -->
<!-- <div class="section-testimonial-carousel section-pt section-pb">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>Our Clients Say</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore</p>
                </div>
            </div>
        </div>
          <ngx-slick-carousel class="carousel"
          #slickModal="slick-carousel"
          [config]="slideConfig"
          (init)="slickInit()"
          (breakpoint)="breakpoint()"
          (afterChange)="afterChange()"
          (beforeChange)="beforeChange()">
        <div ngxSlickItem *ngFor="let slide of slides" class="slide">
        <img src="{{ slide.img }}" alt="slide" width="100%">
        </div>
        </ngx-slick-carousel>
    </div>
  </div> -->

<!-- End Testimonial Style -->


<!-- Start Cyber Security Needs -->
<!-- <div class="section-service section-pt section-pb-60">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div style="margin-bottom: 0;" class="section-title text-center">
                    <h2>Discuss Your Cyber Security Needs Today</h2>
                </div>
            </div>
        </div>
    </div>
  </div> -->

<!-- End Cyber Security Needs -->


<script src="https://kit.fontawesome.com/3ea94799c3.js" crossorigin="anonymous"></script>